import { memberships } from '@webclient/lib/agent';

import {
  CreateMembershipResponseType,
  RoleType,
} from '@webclient/shared-types/memberships';

import { useMutation } from '@tanstack/react-query';

type FnPraramsType = { email: string; role: RoleType };

type ParamsType = {
  onSuccess?: (
    data: CreateMembershipResponseType,
    variables: FnPraramsType,
    context: void,
  ) => Promise<unknown> | unknown;
  onError?: (
    error: Error,
    variables: FnPraramsType,
    context: void | undefined,
  ) => Promise<unknown> | unknown;
};

export default function useCreateInvitation({
  onSuccess,
  onError,
}: ParamsType) {
  const { mutateAsync: createInvitationAsync } = useMutation({
    mutationKey: ['createInvitation'],
    mutationFn: async (param: FnPraramsType) => {
      const { data } = await memberships.createInvitation({
        email: param.email,
        role: param.role,
      });

      return data;
    },
    onError,
    onSuccess,
  });

  return {
    createInvitationAsync,
  };
}
